/* eslint-disable */
import ReactRouterPropTypes from 'react-router-prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const ReportsPagePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The `history` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The `location` props from `react-router`
   */
  location: ReactRouterPropTypes.location.isRequired,

  /**
   * The `match` props from `react-router`
   */
  match: ReactRouterPropTypes.match.isRequired,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default ReportsPagePropTypes;
